var MCAC = require('./_search')();

if (!window.P2A) {
    window.P2A = {};
}
window.P2A.MCAC = MCAC;

window.P2A.MCAC.init();